import type { ReceiptWidthMm } from '@vuelto/print';

export type ReceiptPrintMode = 'off' | 'browser' | 'agent';

export type BranchReceiptPrintConfig = {
  mode: ReceiptPrintMode;
  autoPrint: boolean;
  /** Comanda cocina al cobrar (independiente del ticket cliente). */
  autoPrintComanda: boolean;
  widthMm: ReceiptWidthMm;
  agentUrl: string;
  /** Cola de Windows o destino del agente ("Nombre", "tcp:ip:9100", "share:Nombre"). */
  printerName: string;
  /**
   * Destino para comandas de cocina (mismo agente). Vacío = misma impresora
   * que el ticket. Permite ticket en mostrador + comanda en cocina (tcp:).
   */
  kitchenPrinterName: string;
};

export const DEFAULT_BRANCH_RECEIPT_PRINT_CONFIG: BranchReceiptPrintConfig = {
  mode: 'browser',
  autoPrint: false,
  autoPrintComanda: false,
  widthMm: 72,
  agentUrl: 'http://127.0.0.1:9310',
  printerName: '',
  kitchenPrinterName: '',
};

export type PrintJobResult =
  | { ok: true; transport: ReceiptPrintMode; warning?: string }
  | { ok: false; error: string; transport?: ReceiptPrintMode };
